import { useAuth0 } from '@auth0/auth0-react';
import { Outlet, useLocation } from 'react-router-dom';
import AppLoadingIndicator from '../common/AppLoadingIndicator';
import React from 'react';
import GoogleTagManager from 'common/GoogleTagManager';
import EncryptEmail from 'common/EncryptEmail';

/**
 * Route guard which prevents an UNAUTHENTICATED user from accessing the route
 */
const RequireAuthGuard = (): JSX.Element => {
  const { user, isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();

  if (!isLoading) {
    if (isAuthenticated && user) {
      if (user?.email) {
        EncryptEmail(user!.email).then((result) => {
          GoogleTagManager.sendEmailDuringUserConnection(result);
        });
      }

      return <Outlet />;
    }

    loginWithRedirect({ appState: { returnTo: `${location.pathname}` } });
    return <></>;
  } else {
    return <AppLoadingIndicator />;
  }
};

export default RequireAuthGuard;
